import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store/store';

import "../node_modules/@ag-grid-community/core/dist/styles/ag-grid.css";
import "../node_modules/@ag-grid-community/core/dist/styles/ag-theme-balham.css";
import '@ag-grid-community/client-side-row-model'
import '@ag-grid-community/infinite-row-model'
import '@ag-grid-community/csv-export'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import datePicker from 'vue-bootstrap-datetimepicker';
import 'bootstrap/dist/css/bootstrap.css';
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import { ButtonPlugin, BFormFile, BFormInput, BFormRadioGroup, BFormSelect, BVToastPlugin, BModal, BFormTextarea, BBadge, DropdownPlugin, ModalPlugin, FormTextareaPlugin } from 'bootstrap-vue'

Vue.use(datePicker);
Vue.use(BVToastPlugin);

Vue.component('b-form-file', BFormFile)
Vue.component('b-form-input', BFormInput)
Vue.component('b-form-radio-group', BFormRadioGroup)
Vue.component('b-form-select', BFormSelect)
Vue.component('b-modal', BModal)
Vue.component('b-form-textarea', BFormTextarea)
Vue.component('b-badge', BBadge)
Vue.use(DropdownPlugin)
Vue.use(ModalPlugin)
Vue.use(FormTextareaPlugin)
Vue.use(ButtonPlugin)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
